import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import { getDisabledActions } from '../selectors/getDisabledActions';
import { SegmentCardEvent, SegmentCardOptions, SegmentCardSection, segmentTrackAction } from 'app/middlewares/segment';
import { getCategoriesActions } from '../selectors/getCategoriesActions';
import openPushToGoogleCalendarDropDown
    from '../../../../../../aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/store/actions/openPushToGoogleCalendarDropDown';
import setCategoriesActions
    from '../../../../../../aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/store/actions/setCategoriesActions';
import setDisabledActions
    from '../../../../../../aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/store/actions/setDisabledActions';
import syncGoogleCalendarsList
    from '../../../../../../aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/effects/syncGoogleCalendarsList';

export const showGoogleCalendarsList = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const selectedCardId = state.pushToGoogleCalendar.cardId;
        dispatch(segmentTrackAction(SegmentCardEvent.PUSH_TO_GOOGLE_CALENDAR_DROPDOWN_OPENED, {
            name: SegmentCardOptions.TYPE,
            value: SegmentCardSection.CUSTOM,
        }));
        dispatch(openPushToGoogleCalendarDropDown());
        dispatch(setCategoriesActions(getCategoriesActions(state, selectedCardId)));
        dispatch(setDisabledActions(getDisabledActions(state, selectedCardId)));
        dispatch(syncGoogleCalendarsList());
    };
    return action;
};
